import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";
import {
  ref,
  onMounted,
  defineComponent,
  computed,
} from "@vue/composition-api";
import { filter as Rfilter } from "ramda";
import { ClientForTable } from "@/store/modules/clients";
import { itemRouteBuilder, NamedRts } from "@/router";

import { genericSort, sortIcon } from "@/components/helpers";

export default defineComponent({
  name: "clients",
  components: {
    LoadingAnimation,
  },

  setup(_props, ctx) {
    let $store = ctx.root.$store;

    let dataLoaded = ref(false);
    let loadingMessage = ref("Loading Clients...");

    let filter = ref("");

    let sortKey = ref<"name" | "manager">("name");
    let sortAsc = ref(true);

    const apiClients = computed(() => {
      return $store.getters.clientsForTable as ClientForTable[];
    });

    const localClients = ref<ClientForTable[]>([]);

    const showRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.clientShow, id);
    };

    const editRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.clientEditForm, id);
    };

    const clients = computed(() => {
      let tmpResults = [...localClients.value];

      if (filter.value !== "") {
        let tmpReg = new RegExp(filter.value, "i");
        tmpResults = Rfilter((item: any) => {
          let nameResult = tmpReg.test(item.name);
          let managerResult = tmpReg.test(item.manager);
          let phoneResult = tmpReg.test(item.phoneNumber);

          return nameResult || managerResult || phoneResult;
        }, tmpResults);
      }

      return tmpResults;
    });

    const localSortIcon = (lSortKey: "name" | "manager") => {
      return sortIcon(sortAsc, sortKey, lSortKey);
    };

    const getClientsByStatus = (status: string) => {
      dataLoaded.value = false;
      const jsConn = new JSConn();
      jsConn.formParams = {
        statuses: [status],
      };
      $store.dispatch("needClients", jsConn).then(() => {
        localClients.value = [...apiClients.value];
        // flip the sort, otherwise on load it would be off
        sortAsc.value = !sortAsc.value;
        updateSort(sortKey.value);
        dataLoaded.value = true;
        return Promise.resolve();
      });
    };

    const updateSort = (lSortKey: "name" | "manager") => {
      localClients.value = genericSort(
        [...localClients.value],
        sortAsc,
        sortKey,
        lSortKey,
      );
    };

    onMounted(() => {
      getClientsByStatus("active");
    });

    return {
      dataLoaded,
      loadingMessage,

      clients,

      filter,

      getClientsByStatus,
      updateSort,
      localSortIcon,

      showRouteBuilder,
      editRouteBuilder,
    };
  },
});
